import React from 'react';
import AdminVideoAssignmentCard from './AdminVideoAssignmentCard';

function AdminVideoAssignment(props) {

    const videoLocations = [ 
        { id: "Location1", description: "พิพิธภัณฑ์" }, 
        { id: "Location2", description: "" },
        { id: "Location3", description: "สำนักงานใหญ่ ชั้น 19" }, 
        { id: "Location4", description: "ศูนย์การเรียนรู้" }, 
        { id: "Location5", description: "" },
        { id: "Location6", description: "" }, 
        { id: "Location7", description: "" }, 
        { id: "Location8", description: "" }, 
        { id: "Location9", description: "" }, 
        { id: "Location10", description: "" },
        { id: "Location11", description: "" }, 
        { id: "Location12", description: "" }, 
        { id: "Location13", description: "" }, 
        { id: "Location14", description: "" }, 
        { id: "Location15", description: "" },
        { id: "Location16", description: "" }, 
        { id: "Location17", description: "" }, 
        { id: "Location18", description: "" }, 
        { id: "Location19", description: "" }, 
        { id: "Location20", description: "" },
    ];

    return (
        <div>
        {
            videoLocations.map((el, i) => {
                return (
                    <AdminVideoAssignmentCard location={el} videos={props.videos} />
                );
            })
        }
        </div>
    );
}

export default AdminVideoAssignment;
